import { useAuth } from './useAPI';
import { useAuthStore } from '@/stores/auth';

export default function useSessionValidate() {
  const { sessionValidate } = useAuth();

  const useRouterSessionValidate = async () => {
    const sessionToken = useAuthStore().sessionToken;
    if (!sessionToken) return false; // 토큰이 없는 경우
    try {
      const { alive } = await sessionValidate(sessionToken);
      return alive;
    } catch {
      return false;
    }
  };

  return {
    useRouterSessionValidate,
  };
}
